import './Integrations.css';
import Card from '../../../components/card/Card';
import Label from '../../../components/label/Label';
import React, { useState } from 'react';
import Input from "../../../inputs/input/Input";
import Button from "../../../components/button/Button";
import mainAPI from '../../../api/MainAPI';
import CheckBox from "../../../inputs/checkBox/CheckBox";
import toasts from '../../../utils/toasts';
import {SettingRow} from "../SettingsPage";


const Integrations = ({integrations = [], onUpdate = () => {}} = {}) => {
    const narcLock = integrations.find(({name}) => name === 'NarcLock') || {};

    const [isEnabled, setEnabled] = useState(narcLock.isEnabled);
    const [account, setAccount] = useState(narcLock.account);
    const [username, setUsername] = useState(narcLock.username);
    const [password, setPassword] = useState(narcLock.password);

    const testCredentials = async () => {
        let message = 'Error testing credentials. Please try again later.';
        try {
            const {valid = false} = await mainAPI.narc_lock_integration.test({account, username, password});
            message = valid ? 'Success' : 'Invalid Credentials';
        }
        catch (error) {
            console.error('Error testing credentials', error);
        }
        toasts.show(message);
    }

    const saveCredentials = async () => {
        let message = 'Error saving credentials. Please try again later.';
        try {
            const [{credentials: {account: newAccount} = {}}] = await mainAPI.narc_lock_integration.update({credentials: {username, password, account}});
            if (account === newAccount)  message = 'Success. NarcLock Credentials Were Updated.';
            onUpdate([{...narcLock, isEnabled, username, password, account}]);
        }
        catch (error) {
            console.error('Error saving credentials', error);
        }
        toasts.show(message);
    }

    const toggleIntegration = async (enable) => {
        let message = 'Error toggling NarcLock. Please try again later.';
        try {
            const [{enabled}] = await mainAPI.narc_lock_integration.toggle({enable});
            if (enabled === enable) {
                // Successfully enabled or disabled integration
                setEnabled(enable);

                if (enable) message = 'NarcLock Enabled';
                else {
                    // Disabled integration, clear credentials
                    const [{credentials: {username, password, account}}] =
                        await mainAPI.narc_lock_integration.update(
                            {credentials: {username: '', password: '', account: ''}});

                    const cleared = !username && !password && !account;

                    if (cleared) {
                        setUsername(username);
                        setPassword(password);
                        setAccount(account);
                        message = 'NarcLock Disabled';
                    }
                    else message = 'Error Clearing NarcLock Credentials. Please try again later.';
                }
                onUpdate([{...narcLock, isEnabled, username, password, account}]);
            }
        }
        catch (error) {
            console.error('Error toggling integration', error);
        }
        toasts.show(message)
    }

    const renderWarning = () => {
        if (isEnabled) {
            return (
                <Label className='warning' italic medium red>Disabling the integration will also remove your saved credentials.</Label>
            )
        }
        return (
            <Label className='warning' medium pastel>Enable the integration to test and saved credentials.</Label>
            // <div className='warning'></div>
        )
    }

    return (
        <Card className="inner-card integration-settings">
            <Label bold large black>Integration Settings</Label>
            <Label className="narclock" large black-light>NarcLock</Label>
            <SettingRow>
                <CheckBox className="enabled" title="Enabled" value={isEnabled} onChange={toggleIntegration} />
                <Label gray-dark>Enabled</Label>
            </SettingRow>
            {renderWarning()}
            <Input value={account} onChange={setAccount} placeholder={'Account'} className="account" type="text" disabled={!isEnabled} />
            <Input value={username} onChange={setUsername} placeholder={'Username'} className="username" type="text" disabled={!isEnabled} />
            <Input value={password} onChange={setPassword} placeholder={'Password'} className="password" type="password" disabled={!isEnabled} />
            <Button onClick={testCredentials} className="action" color="white" bg="darkblue" disabled={!isEnabled}>
                Test Credentials
            </Button>
            <Button onClick={saveCredentials} className="action" color="white" bg="blue" disabled={!isEnabled}>
                Save Credentials
            </Button>
        </Card>
    );
}
export default Integrations;



// WEBPACK FOOTER //
// ./src/pages/settingsPage/Integrations/Integrations.jsx